(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    const form = document.getElementById('CartForm');
    if (!form) return;

    form.querySelectorAll('.cart__qty-btn').forEach((btn) => {
      btn.addEventListener('click', () => {
        const line = btn.dataset.line;
        const input = form.querySelector(`.cart__qty-field[data-line="${line}"]`);
        if (!input) return;
        const current = parseInt(input.value, 10) || 0;
        const next = btn.dataset.action === 'increase' ? current + 1 : Math.max(0, current - 1);
        input.value = next;
        form.submit();
      });
    });

    let qtyDebounce;
    form.querySelectorAll('.cart__qty-field').forEach((input) => {
      input.addEventListener('change', () => {
        clearTimeout(qtyDebounce);
        qtyDebounce = setTimeout(() => form.submit(), 350);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    const sections = document.querySelectorAll('.product');
    sections.forEach((section) => {
      const sectionId = section.querySelector('[id^="ProductForm-"]')?.id.replace('ProductForm-', '');
      if (!sectionId) return;

      const variantsScript = section.querySelector(`#ProductVariants-${sectionId}`);
      if (!variantsScript) return;

      let variants = [];
      try {
        variants = JSON.parse(variantsScript.textContent);
      } catch (e) {
        return;
      }

      const form = section.querySelector(`#ProductForm-${sectionId}`);
      const variantIdInput = section.querySelector(`#ProductVariantId-${sectionId}`);
      const addBtn = form?.querySelector('.product__add-btn');
      const priceWrap = section.querySelector('.product__price-wrap');
      const optionInputs = section.querySelectorAll('.product__option-input');
      const mediaItems = section.querySelectorAll('.product__media-item');
      const thumbs = section.querySelectorAll('.product__media-thumb');
      const qtyInput = section.querySelector('.product__quantity-field');
      const qtyBtns = section.querySelectorAll('.product__quantity-btn');

      function formatMoney(cents) {
        return '$' + (cents / 100).toFixed(2);
      }

      function getSelectedOptions() {
        const opts = [];
        section.querySelectorAll('.product__option').forEach((optEl) => {
          const checked = optEl.querySelector('.product__option-input:checked');
          if (checked) opts.push(checked.value);
        });
        return opts;
      }

      function updateOptionLabels() {
        section.querySelectorAll('.product__option').forEach((optEl) => {
          const checked = optEl.querySelector('.product__option-input:checked');
          const label = optEl.querySelector('.product__option-selected');
          if (checked && label) label.textContent = checked.value;
        });
      }

      function findVariant(selectedOptions) {
        return variants.find((v) =>
          v.options.every((opt, i) => opt === selectedOptions[i])
        );
      }

      function showMedia(mediaId) {
        mediaItems.forEach((item) => {
          item.classList.toggle('product__media-item--active', String(item.dataset.mediaId) === String(mediaId));
        });
        thumbs.forEach((t) => {
          t.classList.toggle('product__media-thumb--active', String(t.dataset.mediaId) === String(mediaId));
        });
      }

      function updateVariant() {
        const selected = getSelectedOptions();
        const variant = findVariant(selected);
        updateOptionLabels();

        if (!variant) {
          if (addBtn) {
            addBtn.disabled = true;
            addBtn.querySelector('span').textContent = 'Unavailable';
          }
          return;
        }

        if (variantIdInput) variantIdInput.value = variant.id;

        if (priceWrap) {
          let html = '';
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            html = `<span class="product__price product__price--sale">${formatMoney(variant.price)}</span>` +
              `<span class="product__price-compare">${formatMoney(variant.compare_at_price)}</span>` +
              `<span class="product__price-badge">Sale</span>`;
          } else {
            html = `<span class="product__price">${formatMoney(variant.price)}</span>`;
          }
          priceWrap.innerHTML = html;
        }

        if (addBtn) {
          const span = addBtn.querySelector('span');
          if (variant.available) {
            addBtn.disabled = false;
            if (span) span.textContent = `Add to cart — ${formatMoney(variant.price)}`;
          } else {
            addBtn.disabled = true;
            if (span) span.textContent = 'Sold out';
          }
        }

        if (variant.featured_media && variant.featured_media.id) {
          showMedia(variant.featured_media.id);
        }

        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }

      optionInputs.forEach((input) => input.addEventListener('change', updateVariant));

      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => showMedia(thumb.dataset.mediaId));
      });

      qtyBtns.forEach((btn) => {
        btn.addEventListener('click', () => {
          if (!qtyInput) return;
          const current = parseInt(qtyInput.value, 10) || 1;
          const next = btn.dataset.action === 'increase' ? current + 1 : Math.max(1, current - 1);
          qtyInput.value = next;
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
